<ng-container *transloco="let t; read: 'auth'">
  <div class="flex alignCenter login-container">
    <form
      class="flex flexDirCol alignLeft maxWidth350 login-form"
      [formGroup]="loginForm"
      (submit)="onSubmit()"
    >
      <img src="/assets/logo/logo.svg" class="logo mbl"/>

      <label class="label">{{ t('tenantPlaceholder') }}</label>
      <kendo-textbox
        formControlName="tendantId"
        class="fullWidth mbs"
      ></kendo-textbox>

      <label class="label">{{ t('emailPlaceholder') }}</label>
      <kendo-textbox
        formControlName="email"
        class="fullWidth mbs"
      ></kendo-textbox>

      <label class="label">{{ t('passwordPlaceholder') }}</label>
      <input
        kendoTextBox
        type="password"
        formControlName="password"
        class="fullWidth mbs"
      >

      <button
        [disabled]="loginForm.invalid"
        type="submit"
        kendoButton
        fillMode="solid"
        size="large"
        rounded="large"
        [themeColor]="isLoading ? 'warning' : 'primary'"
      >{{isLoading ? t('loginLoading') : t('login')}}</button>
    </form>
  </div>
  <span id="version">Version {{version}}</span>
</ng-container>
